<template>
  <v-app>
    <template v-if="!isPlatformOwner">
      <dashboard-core-app-bar />
      <dashboard-core-drawer />
    </template>

    <dashboard-core-view />
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),

    computed: {
      isPlatformOwner() {
        try {
          const userStr = localStorage.getItem('user')
          const user = userStr ? JSON.parse(userStr) : null
          return user && user.role === 'PLATFORM_OWNER'
        } catch {
          return false
        }
      },
    },
  }
</script>
